import React from 'react'
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  Tooltip,
  Typography
} from '@mui/material'
import { Add as AddIcon, CalendarToday as CalendarTodayIcon, Delete as DeleteIcon } from '@mui/icons-material'
import { ExceptionScheduleSaveDto, PickupTimeSaveDto } from '../../config/config'

interface ExceptionCardProps {
  exception: ExceptionScheduleSaveDto
  index: number
  isSaving: boolean
  formatDate: (dateStr: string) => string
  onActiveChange: (index: number, active: boolean) => void
  onRemove: (index: number) => void
  onAddPickupTime: (index: number) => void
  onPickupTimeChange: (
    index: number,
    pickupIndex: number,
    field: keyof PickupTimeSaveDto,
    value: string
  ) => void
  onRemovePickupTime: (index: number, pickupIndex: number) => void
  renderPickupTimesTable: (
    pickupTimes: PickupTimeSaveDto[],
    onChangeTime: (index: number, field: keyof PickupTimeSaveDto, value: string) => void,
    onRemove: (index: number) => void,
    emptyMessage: string
  ) => React.ReactNode
}

export const ExceptionCard: React.FC<ExceptionCardProps> = ({
  exception,
  index,
  isSaving,
  formatDate,
  onActiveChange,
  onRemove,
  onAddPickupTime,
  onPickupTimeChange,
  onRemovePickupTime,
  renderPickupTimesTable
}) => (
  <Box sx={{ mb: 2, borderRadius: 1, border: '1px solid', borderColor: 'divider', p: 2 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CalendarTodayIcon fontSize='small' color='action' />
        <Box>
          <Typography variant='subtitle2'>{exception.description}</Typography>
          <Typography variant='caption' color='textSecondary'>
            {formatDate(exception.exceptionDate)}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={exception.active}
              color='primary'
              onChange={(_e, checked) => onActiveChange(index, checked)}
            />
          }
          label='Activo'
        />
        <Tooltip title='Eliminar'>
          <span>
            <IconButton size='small' disabled={isSaving} onClick={() => onRemove(index)}>
              <DeleteIcon fontSize='small' />
            </IconButton>
          </span>
        </Tooltip>
      </Box>
    </Box>

    {exception.active && (
      <Box sx={{ mt: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
          <Typography variant='body2' sx={{ fontWeight: 500 }}>
            Horarios de recolección
          </Typography>
          <Button
            size='small'
            variant='outlined'
            disabled={isSaving}
            startIcon={<AddIcon fontSize='small' />}
            onClick={() => onAddPickupTime(index)}
          >
            Agregar
          </Button>
        </Box>
        {renderPickupTimesTable(
          exception.pickupTimes,
          (pickupIndex, field, value) => onPickupTimeChange(index, pickupIndex, field, value),
          (pickupIndex) => onRemovePickupTime(index, pickupIndex),
          'No hay horarios configurados para esta fecha.'
        )}
      </Box>
    )}
  </Box>
)
